import { Box, Typography } from "@mui/material";

import { AdditionalInterestType } from "@covertree/new-business-graphql";
import {
  AdditionalInterestFormBody,
  AdditionalInterestFormMode,
  useAdditionalInterestForm,
} from "@covertree/features";

import type { AdditionalInterestFormData } from "../types";

const TITLE: Record<AdditionalInterestFormMode, string> = {
  add: "Add additional interest",
  edit: "Edit additional interest",
  replace: "Replace billing",
};

interface AdditionalInterestFormProps {
  readonly onSubmit: (data: AdditionalInterestFormData) => void;
  readonly onClose: () => void;
  readonly interestsCountByType: Record<AdditionalInterestType, number>;
  readonly mode?: AdditionalInterestFormMode;
  readonly selectedInterest?: AdditionalInterestFormData | null;
  readonly isTenantPolicy?: boolean;
}

export const AdditionalInterestForm = ({
  onSubmit,
  onClose,
  interestsCountByType,
  mode = "add",
  selectedInterest = null,
  isTenantPolicy = false,
}: AdditionalInterestFormProps) => {
  const interestForm = useAdditionalInterestForm({
    mode,
    onSubmit,
    onClose,
    interestsCountByType,
    selectedInterest,
    isTenantPolicy,
  });

  return (
    <Box
      position="relative"
      borderRadius="16px"
      paddingX={3}
      paddingY={3}
      marginY={1}
      width={1}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        "& .MuiOutlinedInput-root": {
          backgroundColor: theme.palette.background.default,
        },
      })}>
      <Typography variant="h6" fontSize={18} mb={2}>
        {TITLE[mode]}
      </Typography>

      <AdditionalInterestFormBody {...interestForm} />
    </Box>
  );
};
